const selector = '[data-js-nav-mega-menu-root]';
const megaMenu = function (el, app) {

    const $el = $(el);
    const $lvl2Items = $el.children().eq(0).children(".Ge-Nav-Item");
    const $body = $('body');
    const $lvl1 = $('.Ge-Nav--lvl1');
    const $navAlt = $('.Ge-Nav-Alt');
    const $logo = $('.Ge-Header-Logo');

    const isApplicable = () => !$('html').hasClass('Ge-Nav--mobile');

    const expand = ($item) => {

        const $megaMenu = $item.children('.Ge-MegaMenu');
        if ($megaMenu.length === 1) {
            $lvl2Items.attr('aria-expanded', false);
            $item.attr('aria-expanded', true);
            $body.addClass('Ge--mega-menu-active');
        }
        else {
            collapse();
        }
    }

    const collapse = () => {
        $lvl2Items.attr('aria-expanded', false);
        $body.removeClass('Ge--mega-menu-active')
    }

    const init = function () {

        $lvl2Items.children('a')
        .on('focus', function () {
            if (isApplicable()) {
                expand($(this).parent())
            }
        })
        .on('mouseenter', function () {
            if (isApplicable()) {
                expand($(this).parent())
            }
        });

        // Don't collapse if we're still in the menu or if we opened a modal from the menu
        // The modal part may have to change to be more specific if other modals can be triggered from within the menu that should actually close the menu
        $el.on("mouseleave", function (event) {
            const $t = $(event.relatedTarget);
            if (isApplicable() &&
                $t.closest($lvl1).length === 0 &&
                $t.closest($navAlt).length === 0 &&
                $t.closest($logo).length === 0 &&
                !$t.hasClass('ge-modal-outer')) {
                collapse();
            }
        });
        $el.on("focusout", function (event) {
            if (isApplicable() &&
                $(event.relatedTarget).closest($(this)).length === 0 &&
                $(event.target).closest($(this)).length === 0
            ) {
                collapse();
            }
        });

    }
    return {
        init: init()
    };
};

megaMenu.selector = selector;
export default megaMenu;
